import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth, db } from './firebase-config';
import { doc, getDoc, collection, query, where, onSnapshot } from 'firebase/firestore';
import './BottomNav.css';

// Accept accountType as a prop
const BottomNav = ({ accountType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [unreadMessages, setUnreadMessages] = useState(0);

  // Listen for unread messages
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    // Query conversations where the user is a participant
    const conversationsRef = collection(db, 'conversations');
    const q = query(
      conversationsRef,
      where('participants', 'array-contains', user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let totalUnread = 0;
      snapshot.docs.forEach(docSnapshot => {
        const conversationData = docSnapshot.data();
        if (location.pathname === '/messages') return;
        if (conversationData.lastMessageSenderId && 
            conversationData.lastMessageSenderId !== user.uid) {
          const readBy = conversationData.readBy || [];
          if (!readBy.includes(user.uid)) {
            totalUnread++;
          }
        }
      });
      setUnreadMessages(totalUnread);
    }, (error) => {
      console.error('Error in unread messages listener:', error);
    });

    return () => unsubscribe();
  }, [location.pathname]);

  return (
    <nav className="bottom-nav">
      <button 
        className={`nav-item ${location.pathname === '/job-feed' ? 'active' : ''}`}
        onClick={() => navigate('/job-feed')}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span>Home</span>
      </button>

      <button 
        className={`nav-item ${location.pathname === '/messages' ? 'active' : ''}`}
        onClick={() => navigate('/messages')}
      >
        <div className="nav-icon-container">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {unreadMessages > 0 && location.pathname !== '/messages' && (
            <span className="notification-badge">
              {unreadMessages > 99 ? '99+' : unreadMessages}
            </span>
          )}
        </div>
        <span>Messages</span>
      </button>

      {accountType === 'employer' && (
        <button 
          className={`nav-item ${location.pathname === '/applicants' ? 'active' : ''}`}
          onClick={() => navigate('/applicants')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <span>Jobs</span>
        </button>
      )}
      {accountType === 'employee' && (
        <button 
          className={`nav-item ${location.pathname === '/active-applications' ? 'active' : ''}`}
          onClick={() => navigate('/active-applications')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Applications</span>
        </button>
      )}

      <button 
        className={`nav-item ${location.pathname === '/profile' ? 'active' : ''}`}
        onClick={() => navigate('/profile')}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span>Profile</span>
      </button>
    </nav>
  );
};

export default BottomNav; 